import { render, staticRenderFns } from "./icon-chevrons-right.vue?vue&type=template&id=b55890aa&"
import script from "./icon-chevrons-right.vue?vue&type=script&lang=js&"
export * from "./icon-chevrons-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports